module.exports = __webpack_public_path__ + "img/api.4f1e1e11.png";